export default __webpack_public_path__ + "static/media/home_ghibli_totoro_busStation.856dcb9a.jpg";